import productEmail from '../shared-images/email.webp';
import productEmailHover from '../shared-images/email-hover.webp';
import productSmsMarketing from './images/sms-uk.webp';
import productSmsMarketingHover from '../shared-images/sms-hover.webp';
import productReviews from '../shared-images/reviews.webp';
import productReviewsHover from '../shared-images/reviews-hover.webp';
import productMobilePush from '../shared-images/push.webp';
import productMobilePushHover from '../shared-images/push-hover.webp';
import productCdpMobile from '../shared-images/cdp-mobile.webp';
import productCdpDesktop from '../shared-images/cdp-desktop.webp';

import type { Layout } from 'gatsby-plugin-image';

const ukData = {
  productCards: [ {
    buttonText: 'Email marketing',
    buttonUrl: '/uk/email-marketing',
    mainImage: {
      altText: 'An email with an image of a cosmetics dropper that reads: "Picked for you! Based on other products you enjoy, we bet you\'ll love our Blissful Body Serum. Check it out."',
      gatsbyImage: {
        layout: 'fullWidth' as Layout,
        images: {
          fallback: {
            src: productEmail,
          },
        },
        width: 256,
        height: 462,
      },
    },
    hoverImage: {
      altText: '',
      gatsbyImage: {
        layout: 'fixed' as Layout,
        images: {
          fallback: {
            src: productEmailHover,
          },
        },
        width: 186,
        height: 119,
      },
    },
    text: 'Send rich, engaging emails with dynamic content, like recommended products.',
  },
  {
    
    buttonText: 'SMS marketing',
    buttonUrl: '/uk/sms-marketing',
    mainImage: {
      altText: 'A text message with an image of cosmetics that reads: Alice, you\'ve earned $10 in VIP rewards! Why not try our Silk Body Serum in Blissful Collection? Shop now at https://klv1.io/fGu15',
      gatsbyImage: {
        layout: 'fullWidth' as Layout,
        images: {
          fallback: {
            src: productSmsMarketing,
          },
        },
        width: 256,
        height: 462,
      },
    }, 
    hoverImage: {
      altText: '',
      gatsbyImage: {
        layout: 'fixed' as Layout,
        images: {
          fallback: {
            src: productSmsMarketingHover,
          },
        },
        width: 188,
        height: 146,
      },
    }, 
    text: 'Reach your most engaged VIP customers. You can even have 2-way conversations.',
  },
  {
    buttonText: 'Mobile push',
    buttonUrl: '/uk/mobile-push-marketing',
    mainImage: {
      altText: 'A push notification on a mobile phone that reads: "Order delivered. Alice, your package has arrived. Enjoy!"',
      gatsbyImage: {
        layout: 'fullWidth' as Layout,
        images: {
          fallback: {
            src: productMobilePush,
          },
        },
        width: 256,
        height: 462,
      },
    }, 
    hoverImage: {
      altText: '',
      gatsbyImage: {
        layout: 'fixed' as Layout,
        images: {
          fallback: {
            src: productMobilePushHover,
          },
        },
        width: 183,
        height: 214,
      },
    }, 
    text: 'Boost engagement and delight customers with perfectly timed notifications.',
  },
  {
    buttonText: 'Reviews',
    buttonUrl: '/uk/product-reviews',
    mainImage: {
      altText: 'An email with an image of a woman applying cosmetics that reads: "Our new Blissful Silk Body Serum is a hit!" followed by a customer review: "05/12/23. Alice L. Skin looks and feels flawless!" Five stars."',
      gatsbyImage: {
        layout: 'fullWidth' as Layout,
        images: {
          fallback: {
            src: productReviews,
          },
        },
        width: 256,
        height: 462,
      },
    }, 
    hoverImage: {
      altText: '',
      gatsbyImage: {
        layout: 'fixed' as Layout,
        images: {
          fallback: {
            src:  productReviewsHover,
          },
        },
        width: 113,
        height: 233,
      },
    },
    text: 'Build trust and increase sales by collecting and showcasing customer-written reviews.',
  }],
  cdpCards: {
    buttonText: 'Customer data platform',
    buttonUrl: '/uk/customer-data-platform',
    text: 'The Klaviyo CDP consolidates your tech stack and accelerates your time to value. Unify, transform, and activate your data in ways not possible before.',
    desktopImage: {
      altText: 'Klaviyo CDP interface, with navigation for Intelligence, Transformation, Code, Syncing, and Webhooks. A chart: “Email clicks to purchase funnel”',
      gatsbyImage: {
        layout: 'fullWidth' as Layout,
        images: {
          fallback: {
            src: productCdpDesktop,
          },
        },
        width: 791,
        height: 410,
      },
    },
    mobileImage: { 
      altText: 'Klaviyo CDP interface, with navigation for Intelligence, Transformation, Code, Syncing, and Webhooks. A chart: “Email clicks to purchase funnel”',     
      gatsbyImage: {
        layout: 'fullWidth' as Layout,
        images: {
          fallback: {
            src: productCdpMobile,
          },
        },
        width: 475,
        height: 316,
      },
    },
  },
};




export default ukData;
